import { inject, Injectable } from '@angular/core';
import { IconKey } from '../../../../whitelabel/icon-key.enum';
import { LanguageService } from '../../../core/services/language.service';
import { IconProviderService } from '../../../whitelabel/services/icon-provider.service';
import { ProjectType } from '../enums/project-type.enum';

@Injectable({ providedIn: 'root' })
export class ProjectTypeResolverService {
  private readonly languageService = inject(LanguageService);
  private readonly iconService = inject(IconProviderService);

  private readonly definitionSet: Record<ProjectType, { name: string; icon: string }> = {
    [ProjectType.FIX]: {
      name: this.translate('modules.locations.category.project.fix'),
      icon: this.iconService.getIcon(IconKey.ProjectTypeFix),
    },
    [ProjectType.MOBIL]: {
      name: this.translate('modules.locations.category.project.mobil'),
      icon: this.iconService.getIcon(IconKey.ProjectTypeMobile),
    },
  };

  resolveName(type: ProjectType): string {
    return this.definitionSet[type]?.name || this.translate('general.unknown');
  }

  resolveIcon(type: ProjectType): string {
    return this.definitionSet[type]?.icon || this.iconService.getIcon(IconKey.ProjectTypeFix);
  }

  private translate(key: string): string {
    return this.languageService.getInstant(key);
  }
}
